import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Language,
  DEFAULT_LANGUAGE,
  translations,
  languages,
} from "../../assets/locales/translations";

const LanguageSwitcherComponent = () => {
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const { i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState<Language>(
    languages[i18n.language] || DEFAULT_LANGUAGE
  );

  const toggleMenuOpened = () => {
    setIsOpened(!isOpened);
  };

  const selectLanguage = (language: Language) => {
    setSelectedLanguage(language);
    setIsOpened(false);
    i18n.changeLanguage(language.translationCode);
  };

  return (
    <div className="absolute w-full bg-[#fe0300] pb-2">
      <div className="flex items-center">
        {/* Add logo */}
        <img
          className="ml-4 mr-4 h-8 w-auto"
          src={`./images/logo.svg`}
          alt="Logo"
        />
        <div className="container mx-auto mt-6 flex justify-end px-5">
          <div>
            <button
              onClick={toggleMenuOpened}
              id="languages-button"
              data-dropdown-toggle="dropdown-languages"
              className="rounded-full bg-black py-2 pl-4 pr-[5rem] text-sm text-white"
              type="button"
            >
              <div className="inline-flex items-center gap-2">
                <span
                  className={`fi fis fi-${selectedLanguage.flagCode} rounded-full`}
                ></span>
                {selectedLanguage.languageName}
              </div>
            </button>
            <div
              id="dropdown-languages"
              className={`absolute z-10 ${
                isOpened ? "" : "hidden"
              } divide-y divide-gray-100 rounded-lg bg-white shadow dark:bg-gray-700`}
              style={{ width: "170px" }}
            >
              <ul
                className="py-2 text-xs text-gray-700 dark:text-gray-200"
                aria-labelledby="languages-button"
              >
                {translations.map((language) => {
                  return (
                    <li key={language.flagCode}>
                      <button
                        type="button"
                        onClick={() => selectLanguage(language)}
                        className="inline-flex w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
                      >
                        <div className="inline-flex items-center gap-2">
                          <span
                            className={`fi fis fi-${language.flagCode} rounded-full`}
                          ></span>
                          {language.languageName}
                        </div>
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LanguageSwitcherComponent;
